export const config = {
    apiUrl: 'api',
    keywordUrl: 'api/keywords',
    analyzerUrl: 'api/analyzer',
    documentUrl: 'api/document',
    categoryUrl: 'api/category',
    authUrl: 'api/auth0'
};


// WEBPACK FOOTER //
// ./src/helpers/config.js